export default __webpack_public_path__ + "static/visual-literacy-e809a84553899b6f6365d14d9ce58529.jpg";